import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import tnsLogo from '../../../assets/images/tnslogo.png';
import { Loader } from 'lucide-react';

const OPTVerifying = () => (
  <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
    {/* Header */}
    <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center space-x-1.5">
        <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
          <FiDroplet className="w-3 h-3 text-white" />
        </div>
        <span className="font-bold text-gray-800 text-xs">Fuel Co</span>
      </div>
      <div className="flex items-center space-x-1">
        <span className="text-[10px] text-gray-400">Powered by</span>
        <img src={tnsLogo} alt="TNS" className="h-4" />
      </div>
    </div>

    {/* Content */}
    <div className="flex-1 flex flex-col items-center justify-center px-3">
      <Loader className="w-8 h-8 text-blue-600 animate-spin mb-3" />
      <div className="text-sm font-bold text-gray-800 mb-1">Processing</div>
      <div className="text-xs text-gray-600 mb-3">Please wait...</div>
      <div className="w-32 bg-gray-200 rounded-full h-1.5">
        <div className="bg-blue-600 h-1.5 rounded-full animate-pulse" style={{width: '70%'}}></div>
      </div>
    </div>
  </div>
);

export default OPTVerifying;
